//modificación de otros datos relacionados con el cierre semanal
//  contiene los componentes TopSection, RightSection y CenterSection para mostrar los datos con el mismo formato que en el TCW

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Button } from '@material-ui/core/';

//components:
import TopSection from './cierre_semanal_otrosdatos_components/TopSection';
import CentreSection from './cierre_semanal_otrosdatos_components/CentreSection';
import RightSection from './cierre_semanal_otrosdatos_components/RightSection';

//actions:
import { getOtrosDatosCierreSemanal, updateCierreSemanalOtrosDatosDB } from '../../actions/cierre_semanal_actions';


const styles = theme => ({
    root: {
        padding: '8px 24px',
        margin: theme.spacing(1),
        flexGrow: 1,
    },
    container: {
        width: 1022,
        margin: 0,
        padding: 0
    },
    paper: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: theme.palette.primary.light,
        boxShadow: 'none',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
        margin: '25px 0',
        padding: 10,
    },
    numberTextfield: {
        margin: 0,
        padding: 0,
        backgroundColor: 'white',
        borderRadius: 4,
        width: '55%',
        height: 30,
    },
    numberTextfieldRightSide: {
        margin: 0,
        padding: 0,
        backgroundColor: 'white',
        borderRadius: 4,
        width: '55%',
        height: 30,
        marginTop: -10,
    },
    textArea: {
        display: 'flex',
        alignItems: 'start',
        padding: '5px 5px 5px 5px',
        height: '46px',
        fontSize: 11,
        backgroundColor: 'white',
        borderRadius: 4,
    },
    textAreaCenter: {
        display: 'flex',
        alignItems: 'start',
        padding: '5px 5px 5px 5px',
        height: 75,
        fontSize: 11,
        backgroundColor: 'white',
        borderRadius: 4,
    },
    resize: {
        fontSize: 11,
        fontWeight: 800,
        padding: 0,
        height: 30,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class CierreSemanalOtrosDatos extends React.Component {

    componentDidMount() {
        this.props.getOtrosDatosCierreSemanal(this.props.centroId, this.props.dia);
    };

    constructor(props) {
        super(props);
        this.state = {
            showAll: false,
            showSpinner: true,
        };
    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        //once we get the data:
        if (prevProps.otrosDatosCierreSemanal !== this.props.otrosDatosCierreSemanal) {
            this.setState({
                showAll: true,
            });
        };

        if (prevProps.isLoading !== this.props.isLoading && this.props.isLoading) this.setState({ showSpinner: true });
        if (prevProps.isLoading !== this.props.isLoading && !this.props.isLoading) this.setState({ showSpinner: false });
    };


    hanldeOKClick = () => {

        const otrosDatos = this.props.otrosDatosCierreSemanal;

        if (!this.props.isSemanaCerrada) {
            this.props.updateCierreSemanalOtrosDatosDB(otrosDatos, this.props.centroId, this.props.dia, this.props.nextStep);
        }
        else{
            this.props.nextStep();
        }
    };


    render() {

        const { classes } = this.props;

        if (this.state.showAll && !this.state.showSpinner) {
            return (
                <div className={classes.root} >

                    <div className={classes.container}>
                        {/* container de todo */}

                        {/* parte superior */}
                        <TopSection />

                        <div className={classes.paper}>
                            {/* parte inferior */}
                            <CentreSection />

                            {/* right side */}
                            <RightSection />
                        </div>
                    </div>

                    <div>
                        <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={this.props.prevStep}>Atrás</Button>
                        <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={this.hanldeOKClick} >
                            {this.props.isSemanaCerrada ? 'Siguiente' : 'Guardar'}
                        </Button>
                    </div>
                </div>
            );
        };

        return (
            <div className={classes.spinnerContainer}>
                <CircularProgress className={classes.spinner} color="primary" />
            </div>
        );

    };

};

CierreSemanalOtrosDatos.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    centroId: PropTypes.number.isRequired,
    dia: PropTypes.string.isRequired,
    isSemanaCerrada: PropTypes.bool.isRequired,
    otrosDatosCierreSemanal: PropTypes.object.isRequired,
    prevStep: PropTypes.func.isRequired,
    getOtrosDatosCierreSemanal: PropTypes.func.isRequired,
    updateCierreSemanalOtrosDatosDB: PropTypes.func.isRequired,
};



function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        otrosDatosCierreSemanal: state.otrosDatosCierreSemanal.otrosdatos,
        isLoading: state.otrosDatosCierreSemanal.isLoading,
        centroId: state.centroDiaSelected.centro.id,
        dia: state.centroDiaSelected.dia,
        isSemanaCerrada: state.centroDiaSelected.isSemanaCerrada,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getOtrosDatosCierreSemanal,
        updateCierreSemanalOtrosDatosDB
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CierreSemanalOtrosDatos));
